import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useMemo, useState } from "react";
import { Container, Loading } from "@/components/atoms";
import { GeneralFooter, GeneralHeader, PaymentMethodSetupPanel } from "@/components/organisms";
import { getStripePublishableKey } from "@/helpers/apiHelpers";
import { useLayout } from "@/hooks";
import { useGetPaymentProviderKeysQuery } from "@/redux/apis/paymentMethod/paymentMethodApi";

export const ProfilePaymentMethodSetup = () => {
  const { setFullScreen } = useLayout();
  const { isFetching, data } = useGetPaymentProviderKeysQuery();
  const [clientSecret, setClientSecret] = useState<string | undefined>(undefined);

  const stripePromise = useMemo(() => {
    const key = data?.publishable_key || getStripePublishableKey();
    return key ? loadStripe(key) : null;
  }, [data?.publishable_key]);

  useEffect(() => {
    setFullScreen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data?.intent_secret) setClientSecret(data.intent_secret);
  }, [data]);

  return (
    <div className="flex min-h-screen flex-col overflow-hidden md:flex-row">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader action="skip" />
        <Container className="relative flex w-full max-w-[1040px] flex-1 justify-center px-5 pb-[234px] pt-[100px]">
          {isFetching && <Loading className="!bg-transparent" />}
          {stripePromise && clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <PaymentMethodSetupPanel />
            </Elements>
          )}
        </Container>
        <GeneralFooter />
      </div>
    </div>
  );
};
